/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Next_TitleInputs */

const en_wc_tut_next_title = /** @type {(inputs: Wc_Tut_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next steps`)
};

/**
* | output |
* | --- |
* | "Next steps" |
*
* @param {Wc_Tut_Next_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_next_title = /** @type {((inputs?: Wc_Tut_Next_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Next_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_next_title(inputs)
});
export { wc_tut_next_title as "wc.tut.next_title" }